import type { ArenaBounds, BoxCollider } from './types';

export const LAB_ARENA: ArenaBounds = {
  minX: -6,
  maxX: 6,
  minZ: -6,
  maxZ: 6,
};

/** Tall column, low-wide bench, cube, 3×2 m wall slab. */
export const LAB_COLLIDERS: BoxCollider[] = [
  { center: [-2.2, 1.3, -1.6], half: [0.35, 1.3, 0.35] },
  { center: [2.1, 0.22, -0.2], half: [1.45, 0.22, 0.7] },
  { center: [0.2, 0.5, 2.5], half: [0.5, 0.5, 0.5] },
  { center: [-4.5, 1.0, 1.6], half: [0.09, 1.0, 1.5] },
];

export const TALL_BOX = LAB_COLLIDERS[0];
export const LOW_BOX = LAB_COLLIDERS[1];
export const CUBE_BOX = LAB_COLLIDERS[2];
export const WALL_SLAB = LAB_COLLIDERS[3];
